import { render, staticRenderFns } from "./PageJumpDialog.vue?vue&type=template&id=831813a2&scoped=true"
import script from "./PageJumpDialog.vue?vue&type=script&lang=js"
export * from "./PageJumpDialog.vue?vue&type=script&lang=js"
import style0 from "./PageJumpDialog.vue?vue&type=style&index=0&id=831813a2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831813a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('831813a2')) {
      api.createRecord('831813a2', component.options)
    } else {
      api.reload('831813a2', component.options)
    }
    module.hot.accept("./PageJumpDialog.vue?vue&type=template&id=831813a2&scoped=true", function () {
      api.rerender('831813a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pageJump/components/PageJumpDialog.vue"
export default component.exports